// Controlled B1 mirror: only its existing pure sibling ordering dependency.
module.exports = { orderedItems: require('../quote-line-structure').orderedItems };
